<template>
  <div class="all">
    <!-- :span-method="objectOneMethod" -->
    <div class="table">
      <!-- 院校志愿 -->
      <el-table v-if="showMode === 1" :key="1" size="mini" ref="table" style="width: 100%" :max-height="tableHeigth"
                :data="planList"
                :span-method="objectOneMethod" border :row-class-name="tableRowClassName"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" min-width="80" v-if="volunteerMode !== 3" key="collegeCode"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="collegeName" label="院校名称" min-width="100" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="scoreCollege" :label="year + '最低分'" width="65" v-if="volunteerMode === 2"
                         key="scoreCollege">
        </el-table-column>
        <el-table-column prop="accumulate" :label="year + '最低分'" min-width="65" :show-overflow-tooltip="true"
                         v-if="volunteerMode === 3" key="accumulate">
        </el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" :show-overflow-tooltip="true"
                         v-if="volunteerMode === 3"
                         key="specialtyNames" min-width="100"></el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true" min-width="120"
                         v-if="volunteerMode === 3" key="specialtyOptions"></el-table-column>
        <el-table-column label="包含专业" min-width="100" show-overflow-tooltip v-if="volunteerMode === 3"
                         key="specialtyName">
          <template slot-scope="scope">
            {{ scope.row.specialtyName ? scope.row.specialtyName : "无" }}
          </template>
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="80" show-overflow-tooltip v-if="volunteerMode === 3"
                         key="requiredType">
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低分'" width="65" v-if="volunteerMode !== 2" key="scoreYearThis">
          <template slot-scope="scope">
            {{ scope.row.scoreYearThis ? scope.row.scoreYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72" v-if="volunteerMode !== 2" key="accumulateYearThis">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearThis ? scope.row.accumulateYearThis : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '最低位次'" width="72" v-if="volunteerMode !== 2" key="accumulateYearLast">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearLast ? scope.row.accumulateYearLast : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 2 + '最低位次'" width="72" v-if="volunteerMode !== 2" key="accumulateYearOther">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearOther ? scope.row.accumulateYearOther : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear - 1 + '计划数'" width="65" v-if="volunteerMode !== 2" key="planYearLast">
          <template slot-scope="scope">
            {{ scope.row.planYearLast ? scope.row.planYearLast : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear + '计划数'" width="65" v-if="volunteerMode !== 2" key="planYearThis">
          <template slot-scope="scope">
            {{ scope.row.planYearThis ? scope.row.planYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="60" v-if="volunteerMode !== 2" key="planDiff">
          <template slot-scope="scope">
            {{ scope.row.planDiff ? scope.row.planDiff : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" :show-overflow-tooltip="true" min-width="80">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" :show-overflow-tooltip="true" min-width="100">
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="130" show-overflow-tooltip v-if="volunteerMode === 2"
                         key="requiredType1">
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低分'" width="65" v-if="volunteerMode === 2" key="scoreYearThis1">
          <template slot-scope="scope">
            {{ scope.row.scoreYearThis ? scope.row.scoreYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72" v-if="volunteerMode === 2" key="accumulateYearThis1">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearThis ? scope.row.accumulateYearThis : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '最低位次'" width="72" v-if="volunteerMode === 2" key="accumulateYearLast1">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearLast ? scope.row.accumulateYearLast : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 2 + '最低位次'" width="72" v-if="volunteerMode === 2" key="accumulateYearOther1">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearOther ? scope.row.accumulateYearOther : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear - 1 + '计划数'" width="65" v-if="volunteerMode === 2" key="planYearLast1">
          <template slot-scope="scope">
            {{ scope.row.planYearLast ? scope.row.planYearLast : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear + '计划数'" width="65" v-if="volunteerMode === 2" key="planYearThis1">
          <template slot-scope="scope">
            {{ scope.row.planYearThis ? scope.row.planYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="60" v-if="volunteerMode === 2" key="planDiff1">
          <template slot-scope="scope">
            {{ scope.row.planDiff ? scope.row.planDiff : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72" v-if="volunteerMode === 1" key="accumulateYearThis2">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearThis2 ? scope.row.accumulateYearThis2 : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '最低位次'" width="72" v-if="volunteerMode === 1" key="accumulateYearLast2">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearLast2 ? scope.row.accumulateYearLast2 : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72" v-if="volunteerMode === 3" key="score">
          <template slot-scope="scope">
            {{ scope.row.score ? scope.row.score : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '最低位次'" width="72" v-if="volunteerMode === 3" key="scoreCollege1">
          <template slot-scope="scope">
            {{ scope.row.scoreCollege ? scope.row.scoreCollege : 0 }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 专业组 -->
      <el-table v-if="showMode === 3" :key="3" size="mini" ref="table" style="width: 100%" :data="planList"
                :span-method="objectOneMethod" border :row-class-name="tableRowClassName"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
        <el-table-column prop="aspirationName" label="志愿" width="60">
          <template slot-scope="scope">
            {{ scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column
          prop="collegeCode"
          label="院校代码"
          min-width="80"
          :show-overflow-tooltip="true"
        >
        </el-table-column>
        <el-table-column
          prop="collegeName"
          label="院校名称"
          :show-overflow-tooltip="true"
          min-width="120"
        >
        </el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" :show-overflow-tooltip="true" min-width="100">
        </el-table-column>
        <el-table-column prop="specialtyOptions" label="专业组名称" :show-overflow-tooltip="true" min-width="150">
        </el-table-column>
        <el-table-column label="包含专业" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ scope.row.aspirationName ? scope.row.aspirationName : "无" }}
          </template>
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低分'" width="65">
          <template slot-scope="scope">
            {{ scope.row.scoreYearThis ? scope.row.scoreYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearThis ? scope.row.accumulateYearThis : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear - 1 + '计划数'" width="65">
          <template slot-scope="scope">
            {{ scope.row.planYearLast ? scope.row.planYearLast : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear + '计划数'" width="65">
          <template slot-scope="scope">
            {{ scope.row.planYearThis ? scope.row.planYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="68">
          <template slot-scope="scope">
            {{ scope.row.planDiff ? scope.row.planDiff : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" width="80">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" min-width="150" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72">
          <template slot-scope="scope">
            {{ scope.row.score ? scope.row.score : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '最低位次'" width="72">
          <template slot-scope="scope">
            {{ scope.row.scoreCollege ? scope.row.scoreCollege : 0 }}
          </template>
        </el-table-column>
      </el-table>
      <!-- 专业 -->
      <el-table v-if="showMode === 2" :key="2" ref="table" size="mini" style="width: 100%" :data="planList"
                :span-method="objectOneMethod" border :row-class-name="tableRowClassName"
                :header-cell-style="{ 'text-align': 'center', 'font-size': '14px' }"
                :cell-style="{ 'text-align': 'center', 'font-size': '14px' }">
        <el-table-column label="志愿" width="60">
          <template slot-scope="scope">
            {{ volunteerMode === 2 ? scope.row.psort : scope.row.sort }}
          </template>
        </el-table-column>
        <el-table-column prop="collegeCode" label="院校代码" min-width="80" v-if="volunteerMode !== 3" key="collegeCode3"
                         :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="collegeName" label="院校名称" key="collegeName3" v-if="volunteerMode !== 3"
                         :show-overflow-tooltip="true" min-width="120">
        </el-table-column>
        <el-table-column prop="scoreCollege" :label="year + '最低分'" width="65" key="scoreCollege3"
                         v-if="volunteerMode !== 3">
        </el-table-column>
        <el-table-column prop="specialtyNames" label="专业组代码" :show-overflow-tooltip="true"
                         v-if="volunteerMode === 3"
                         key="specialtyNames3" min-width="100"></el-table-column>
        <el-table-column prop="specialtyOptions" key="specialtyOptions3" label="专业组名称"
                         :show-overflow-tooltip="true"
                         min-width="150" v-if="volunteerMode === 3"></el-table-column>
        <el-table-column prop="specialtyCode" label="专业代码" width="100">
        </el-table-column>
        <el-table-column prop="specialtyName" label="专业名称" min-width="150" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column label="选考科目要求" min-width="130" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ matchRequiredType(scope.row.requiredType) }}</span>
            <span v-if="scope.row.requiredType !== 0">{{ scope.row.requiredDiscipline }}</span>
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低分'" width="65">
          <template slot-scope="scope">
            {{ scope.row.scoreYearThis ? scope.row.scoreYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="year + '最低位次'" width="72">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearThis ? scope.row.accumulateYearThis : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 1 + '最低位次'" width="72">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearLast ? scope.row.accumulateYearLast : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="year - 2 + '最低位次'" width="72">
          <template slot-scope="scope">
            {{
              scope.row.accumulateYearOther ? scope.row.accumulateYearOther : 0
            }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear - 1 + '计划数'" width="65">
          <template slot-scope="scope">
            {{ scope.row.planYearLast ? scope.row.planYearLast : 0 }}
          </template>
        </el-table-column>
        <el-table-column :label="nowyear + '计划数'" width="65">
          <template slot-scope="scope">
            {{ scope.row.planYearThis ? scope.row.planYearThis : 0 }}
          </template>
        </el-table-column>
        <el-table-column label="计划增减" width="68">
          <template slot-scope="scope">
            {{ scope.row.planDiff ? scope.row.planDiff : 0 }}
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Sortable from "sortablejs";
import lpyMixin from "@/mixin/lpyMixin";

export default {
  mixins: [lpyMixin],
  components: {
    Sortable,
  },
  props: {
    draftform: {
      type: Array,
      default: () => [],
    },
    voPa: {
      type: Number,
      default: 0,
    },
    switchValue: {
      type: Number,
      default: 1,
    },
  },
  data() {
    return {
      volunteerMode: 1,
      showMode: 1,
      year: new Date().getFullYear(),
      pos: 0,
      pos1: 0,
      planList: [],
      tableHeightSubtract: 300,
      // grouptable: [],
      oldSOrt: 0,
      nowyear: new Date().getFullYear(),
      spanArr: [], //用于存放每一行记录的合并数
      spanArr1: [],
    };
  },
  watch: {
    draftform: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.planList = newValue || [];
        if (this.planList.length > 0 && this.planList[0].admissionYear) {
          this.year = this.planList[0].admissionYear;
        } else {
          this.year = new Date().getFullYear();
        }
      },
      deep: true,
    },
    voPa: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.volunteerMode = newValue;
        this.$nextTick(() => {
          this.$refs.table.doLayout(); //解决表格错位
        });
        console.log(this.volunteerMode, "this.isflag");
      },
      deep: true,
    },
    switchValue: {
      immediate: true, //绑定值就开始执行监听，而不是等值改变。
      handler(newValue, oldValue) {
        this.showMode = newValue;
        console.log(this.showMode, "this.showMode");
        setTimeout(() => {
          this.$nextTick(() => {
            this.$refs.table.doLayout(); //解决表格错位
          });
          this.computeMerging();
        }, 1000);
      },
      deep: true,
    },
  },
  mounted() {
    this.getyear();
  },
  methods: {
    matchRequiredType(requiredType) {
      switch (requiredType) {
        case 0:
          return "不提科目要求";
        case 1:
          return "任选一门报考：";
        case 2:
          return "均报考：";
      }
    },

    //计算合并位置
    computeMerging() {
      this.spanArr = [];
      // data就是我们从后台拿到的数据
      for (var i = 0; i < this.planList.length; i++) {
        if (i === 0) {
          this.spanArr.push(1);
          this.pos = 0;
        } else {
          // 判断当前元素与上一个元素是否相同
          if (
              this.planList[i].collegeName ===
              this.planList[i - 1].collegeName &&
              this.planList[i].specialtyOptions ===
              this.planList[i - 1].specialtyOptions
          ) {
            this.spanArr[this.pos] += 1;
            this.spanArr.push(0);
          } else {
            this.spanArr.push(1);
            this.pos = i;
          }
        }
        console.log(this.spanArr, "this.spanArr");
      }
      if (this.volunteerMode === 3 && this.showMode === 1) {
        this.spanArr1 = [];
        // data就是我们从后台拿到的数据
        for (var i = 0; i < this.planList.length; i++) {
          if (i === 0) {
            this.spanArr1.push(1);
            this.pos1 = 0;
          } else {
            // 判断当前元素与上一个元素是否相同
            if (
                this.planList[i].collegeName === this.planList[i - 1].collegeName
            ) {
              this.spanArr1[this.pos1] += 1;
              this.spanArr1.push(0);
            } else {
              this.spanArr1.push(1);
              this.pos1 = i;
            }
          }
        }
      }
    },
    //进行表格合并
    objectOneMethod({row, column, rowIndex, columnIndex}) {
      const _row = this.spanArr[rowIndex];
      const _row1 = this.spanArr1[rowIndex];
      if (this.volunteerMode === 1 && this.showMode === 1) {
        if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 2 ||
            columnIndex === 3 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6 ||
            columnIndex === 7 ||
            columnIndex === 8 ||
            columnIndex === 9
        ) {
          return {
            rowspan: _row,
            colspan: 1,
          };
        }
      }
      if (this.volunteerMode === 2 && this.showMode === 1) {
        if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 2 ||
            columnIndex === 3
        ) {
          return {
            rowspan: _row,
            colspan: 1,
          };
        }
      }
      if (this.volunteerMode === 1 && this.showMode === 2) {
        if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 2
            // columnIndex === 5 ||
            // columnIndex === 6 ||
            // columnIndex === 7 ||
            // columnIndex === 8 ||
            // columnIndex === 9 ||
            // columnIndex === 10 ||
            // columnIndex === 11
        ) {
          return {
            rowspan: _row,
            colspan: 1,
          };
        }
      }
      if (this.volunteerMode === 3 && this.showMode === 3) {
        if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 2 ||
            columnIndex === 3 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6 ||
            columnIndex === 7 ||
            columnIndex === 8 ||
            columnIndex === 9 ||
            columnIndex === 10 ||
            columnIndex === 11
        ) {
          return {
            rowspan: _row,
            colspan: 1,
          };
        }
      }
      if (this.volunteerMode === 3 && this.showMode === 1) {
        if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2) {
          return {
            rowspan: _row1,
            colspan: 1,
          };
        }
        if (
            columnIndex === 3 ||
            columnIndex === 4 ||
            columnIndex === 5 ||
            columnIndex === 6 ||
            columnIndex === 7 ||
            columnIndex === 8 ||
            columnIndex === 9 ||
            columnIndex === 10 ||
            columnIndex === 11 ||
            columnIndex === 12 ||
            columnIndex === 13
        ) {
          return {
            rowspan: _row,
            colspan: 1,
          };
        }
      }
      if (this.volunteerMode === 3 && this.showMode === 2) {
        if (
            columnIndex === 0 ||
            columnIndex === 1 ||
            columnIndex === 2 ||
            columnIndex === 3 ||
            columnIndex === 4
            // columnIndex === 7 ||
            // columnIndex === 8 ||
            // columnIndex === 9 ||
            // columnIndex === 10 ||
            // columnIndex === 11 ||
            // columnIndex === 12 ||
            // columnIndex === 13
        ) {
          return {
            rowspan: _row,
            colspan: 1,
          };
        }
      }
    },
    //计算预录取行样式
    tableRowClassName({row}) {
      if (row.status === 2) {
        return "finish";
      }
      if (row.type === 1) {
        return "chong";
      }
      if (row.type === 2) {
        return "wen";
      }
      if (row.type === 3) {
        return "bao";
      }
      if (row.classStripe) {
        return "warning-row";
      }
      return "";
    },
    // 获取年份
    getyear() {
      let date = new Date();
      this.nowyear = date.getFullYear();
    },
  },
};
</script>

<style lang="less" scoped>
.all {
  /deep/ .el-table--border th.gutter:last-of-type {
    display: table-cell !important;
  }

  .table {
    // padding-top: 30px;
  }
}

/deep/ .finish {
  background-color: #4ea7fa !important;
  color: #fff;
}

// /deep/.chong {
//   background-color: #ffffff !important;
// }
// /deep/.wen {
//   background-color: #ebfcf5 !important;
// }
// /deep/.bao {
//   background-color: #d7faeb !important;
// }
/deep/ .warning-row {
  // background: #fafafa;
}
</style>
